// Configuración única del menú (v5.0.0). La usan el Sidebar y el Inicio tipo
// kanban. Solo 4 categorías para todos los roles:
//   1 Administración · 2 Diagnóstico · 3 Clases en vivo · 4 Tecnología
import {
  Users, GraduationCap, BookOpen, Video, ClipboardList, Building2, ShieldCheck, History, Layers,
  FolderCheck, Sparkles, BookOpenCheck, BarChart3, Briefcase, Stethoscope, Wallet, CalendarRange,
  CalendarDays, User as UserIcon, Sprout, HelpCircle, Settings, Radio, Network, Film,
  MessagesSquare, Megaphone, Gauge, Cpu, Library, LineChart, Activity, SlidersHorizontal, ClipboardCheck, ListChecks, Lock,
} from "lucide-react";

export const GROUP_META = {
  administracion: { label: "Administración", icon: Briefcase, color: "#315197", tint: "#DDE5F7", sub: "Usuarios, KPIs y gestión" },
  diagnostico: { label: "Diagnóstico", icon: Stethoscope, color: "#A43790", tint: "#F3DDEE", sub: "Perfiles, rutas y cuestionarios" },
  "clases-vivo": { label: "Clases en vivo", icon: Radio, color: "#05A859", tint: "#D8F1E4", sub: "Videollamada, agenda y comunicación" },
  tecnologia: { label: "Tecnología", icon: Cpu, color: "#EF7015", tint: "#FBE3D2", sub: "Configuración y ayuda" },
};
export const GROUP_ORDER = ["administracion", "diagnostico", "clases-vivo", "tecnologia"];

// Paleta de los iconos de aplicación (colores del Manual de Marca).
const C = {
  blue: ["#4F6FD0", "#2C49A0"], purple: ["#C257AE", "#A43790"], green: ["#2EC27E", "#05A859"],
  orange: ["#FF9747", "#EF7015"], yellow: ["#FFD960", "#F2B705"], pink: ["#EE62B0", "#D43790"],
  violet: ["#B98AF0", "#7B4FD0"], sky: ["#55B7F0", "#2C8FD0"], teal: ["#2FC9C0", "#12998F"], red: ["#F2706F", "#D64545"],
};

const it = (to, label, icon, testid, color, extra = {}) => ({ to, label, icon, testid, color: C[color], ...extra });

function build(p, t, items) {
  // items: [groupId, to-suffix, label, icon, testid-suffix, color, extra]
  const out = {};
  GROUP_ORDER.forEach((g) => { out[g] = []; });
  items.forEach(([g, suffix, label, icon, tid, color, extra]) => {
    out[g].push(it(`/${p}/${suffix}`, label, icon, `nav-${t}-${tid}`, color, extra));
  });
  return GROUP_ORDER.map((g) => ({ id: g, ...GROUP_META[g], children: out[g] })).filter((g) => g.children.length);
}

export const NAVS = {
  admin: build("admin", "admin", [
    ["administracion", "dashboard", "Resumen ejecutivo", BarChart3, "dashboard", "blue"],
    ["administracion", "reportes", "Reportes ejecutivos", LineChart, "reportes", "violet", { requiresModule: "M9" }],
    ["administracion", "usuarios", "Usuarios", Users, "usuarios", "sky"],
    ["administracion", "franquicias", "Franquicias", Building2, "franquicias", "orange"],
    ["administracion", "jerarquia", "Jerarquía", Network, "jerarquia", "teal"],
    ["administracion", "perfiles-permisos", "Perfiles de acceso", Layers, "perfiles-permisos", "purple"],
    ["administracion", "roles", "Roles", ShieldCheck, "roles", "green"],
    ["administracion", "auditoria", "Auditoría", History, "auditoria", "red"],
    ["administracion", "capacitacion", "Capacitación docente", GraduationCap, "capacitacion", "yellow", { requiresModule: "M7" }],
    ["administracion", "marketing", "Captación (Leads)", Megaphone, "marketing", "pink", { requiresModule: "M13" }],
    ["administracion", "pagos", "Pagos y planes", Wallet, "pagos", "green", { requiresModule: "M12" }],
    ["administracion", "finanzas", "Resumen financiero", Wallet, "finanzas", "yellow", { soon: true }],
    ["administracion", "plan-qa", "Plan QA", FolderCheck, "plan-qa", "teal", { requiresModule: "MQA" }],
    ["administracion", "mi-perfil", "Mi perfil", UserIcon, "mi-perfil", "blue"],

    ["diagnostico", "perfiles-estudiantes", "Perfiles y diagnóstico", UserIcon, "perfiles-estudiantes", "purple", { requiresModule: "M8" }],
    ["diagnostico", "cuestionarios", "Cuestionarios CEP·CAD", Sparkles, "cuestionarios", "pink"],
    ["diagnostico", "asignar-cuestionarios", "Asignar diagnósticos", ClipboardList, "asignar-cuestionarios", "pink"],
    ["diagnostico", "resultados-cep", "Resultados de diagnósticos", ClipboardList, "resultados-cep", "blue"],
    ["diagnostico", "biblioteca-recursos", "Biblioteca de recursos", Library, "biblioteca-recursos", "orange"],
    ["diagnostico", "repositorio", "Repositorio Drive", Lock, "repositorio", "violet", { requiresModule: "MREPO" }],

    ["clases-vivo", "clases-en-vivo", "Programación de clases", CalendarRange, "clases-vivo", "green"],
    ["clases-vivo", "calendario", "Calendario", CalendarDays, "calendario", "sky"],
    ["clases-vivo", "monitor-clases", "Monitor en vivo", Video, "monitor-clases", "red"],
    ["clases-vivo", "grabaciones", "Grabaciones", Film, "grabaciones", "red"],
    ["clases-vivo", "comunicaciones", "Mensajería", MessagesSquare, "comunicaciones", "violet", { requiresModule: "M11" }],

    ["tecnologia", "configuracion", "Configuración del sistema", Settings, "configuracion", "blue", { requiresSuperAdmin: true }],
    ["tecnologia", "configuracion-motor", "Configuración del motor", Gauge, "configuracion-motor", "orange", { requiresSuperAdmin: true }],
    ["tecnologia", "videollamada/configuracion", "Configuración de videollamada", SlidersHorizontal, "video-config", "violet"],
    ["tecnologia", "videollamada", "Estado de videollamada", Activity, "video-estado", "green"],
    ["tecnologia", "cola-informes", "Cola de informes", ListChecks, "cola-informes", "orange"],
    ["tecnologia", "documentacion", "Ayuda y documentación", HelpCircle, "documentacion", "teal"],
  ]),
  franquiciado: build("franquiciado", "fra", [
    ["administracion", "franquicia", "Mi franquicia", Building2, "franquicia", "orange"],
    ["administracion", "usuarios", "Mis usuarios", Users, "usuarios", "sky"],
    ["administracion", "jerarquia", "Jerarquía", Network, "jerarquia", "teal"],
    ["administracion", "perfiles-permisos", "Perfiles de acceso", Layers, "perfiles-permisos", "purple"],
    ["administracion", "roles", "Roles", ShieldCheck, "roles", "green"],
    ["administracion", "auditoria", "Auditoría", History, "auditoria", "red"],
    ["administracion", "reportes", "Reportes ejecutivos", LineChart, "reportes", "violet", { requiresModule: "M9" }],
    ["administracion", "marketing", "Captación (Leads)", Megaphone, "marketing", "pink", { requiresModule: "M13" }],
    ["administracion", "pagos", "Pagos y planes", Wallet, "pagos", "green", { requiresModule: "M12" }],
    ["administracion", "finanzas", "Resumen financiero", Wallet, "finanzas", "yellow", { soon: true }],
    ["administracion", "mi-perfil", "Mi perfil", UserIcon, "mi-perfil", "blue"],

    ["diagnostico", "perfiles-estudiantes", "Perfiles y diagnóstico", UserIcon, "perfiles-estudiantes", "purple", { requiresModule: "M8" }],
    ["diagnostico", "asignar-cuestionarios", "Asignar diagnósticos", ClipboardList, "asignar-cuestionarios", "pink"],
    ["diagnostico", "resultados-cep", "Resultados de diagnósticos", BarChart3, "resultados-cep", "blue"],

    ["clases-vivo", "clases-en-vivo", "Programación de clases", CalendarRange, "clases-vivo", "green"],
    ["clases-vivo", "calendario", "Calendario", CalendarDays, "calendario", "sky"],
    ["clases-vivo", "grabaciones", "Grabaciones", Film, "grabaciones", "red"],
    ["clases-vivo", "comunicaciones", "Mensajería", MessagesSquare, "comunicaciones", "violet", { requiresModule: "M11" }],

    ["tecnologia", "documentacion", "Ayuda y documentación", HelpCircle, "documentacion", "teal"],
  ]),
  docente: build("docente", "doc", [
    ["administracion", "dashboard", "Resumen", BarChart3, "dashboard", "blue"],
    ["administracion", "mis-estudiantes", "Mis estudiantes", Users, "mis-estudiantes", "sky"],
    ["administracion", "cursos", "Mis cursos", BookOpen, "cursos", "yellow", { requiresModule: "M7" }],
    ["administracion", "mi-perfil", "Mi perfil", UserIcon, "mi-perfil", "purple"],

    ["diagnostico", "perfiles-estudiantes", "Perfiles y diagnóstico", UserIcon, "perfiles-estudiantes", "purple", { requiresModule: "M8" }],
    ["diagnostico", "cuestionarios", "Asignar diagnósticos", ClipboardList, "cuestionarios", "pink"],
    ["diagnostico", "resultados", "Resultados de diagnósticos", BarChart3, "resultados", "blue"],
    ["diagnostico", "resultados-academicos", "Diagnósticos académicos", BookOpenCheck, "resultados-academicos", "teal"],
    ["diagnostico", "biblioteca-recursos", "Biblioteca de recursos", Library, "biblioteca-recursos", "orange"],

    ["clases-vivo", "clases-en-vivo", "Mis clases en vivo", Radio, "clases-vivo", "green"],
    ["clases-vivo", "calendario", "Calendario", CalendarDays, "calendario", "sky"],
    ["clases-vivo", "grabaciones", "Grabaciones", Film, "grabaciones", "red"],
    ["clases-vivo", "comunicaciones", "Mensajería", MessagesSquare, "comunicaciones", "violet", { requiresModule: "M11" }],

    ["tecnologia", "documentacion", "Ayuda y documentación", HelpCircle, "documentacion", "teal"],
  ]),
  estudiante: build("estudiante", "est", [
    ["administracion", "perfil", "Mi información", UserIcon, "perfil", "blue"],

    ["diagnostico", "cuestionarios", "Mis diagnósticos", BookOpenCheck, "cuestionarios", "purple"],
    ["diagnostico", "ruta", "Mi ruta evolutiva", Sprout, "ruta", "green"],

    ["clases-vivo", "clases-en-vivo", "Mis clases en vivo", Radio, "clases-vivo", "orange"],
    ["clases-vivo", "calendario", "Calendario", CalendarDays, "calendario", "sky"],
    ["clases-vivo", "grabaciones", "Mis grabaciones", Film, "grabaciones", "red"],
    ["clases-vivo", "evaluacion-clase", "Evaluar mis clases", ClipboardCheck, "evaluacion-clase", "yellow"],
    ["clases-vivo", "comunicaciones", "Mensajería", MessagesSquare, "comunicaciones", "violet", { requiresModule: "M11" }],

    ["tecnologia", "documentacion", "Ayuda y documentación", HelpCircle, "documentacion", "teal"],
  ]),
};

// Testids históricos que otros módulos/tests pueden usar.
export const ROLE_HOME = {
  admin: "/admin/inicio",
  franquiciado: "/franquiciado/inicio",
  docente: "/docente/inicio",
  estudiante: "/estudiante/inicio",
};

export function visibleChildren(group, modules = [], isSuperAdmin = false) {
  return group.children.filter((c) => {
    if (c.requiresModule && !modules.includes(c.requiresModule)) return false;
    if (c.requiresSuperAdmin && !isSuperAdmin) return false;
    return true;
  });
}
